import React, { useState } from "react";
import JobSummary from "../../Components/ReportsItems/JobSummaryTab/JobSummary";
import CCInvoiceSummary from "../../Components/ReportsItems/CCInvoiceSummaryTab/CCInvoiceSummary";
import TCInvoiceSummary from "../../Components/ReportsItems/TCInvoiceSummaryTab/TCInvoiceSummary";

const Reports = () => {
    const [activeTab, setActiveTab] = useState("job");

    return (
        <main className="full-wraper">
            <div className="main-wraper">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="white-wraper">
                                <div className="ct-tabs mt-0">
                                    <ul className="nav nav-tabs jtabs" id="myTab" role="tablist">
                                        <li className="nav-item" role="presentation">
                                            <button className={`nav-link ctt-button ${activeTab === "job" ? "active" : ""}`} onClick={() => setActiveTab("job")} >
                                                <span>Job Summary</span>
                                            </button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button className={`nav-link ctt-button ${activeTab === "tc" ? "active" : ""}`} onClick={() => setActiveTab("tc")} >
                                                <span>TC Invoice Summary</span>
                                            </button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button className={`nav-link ctt-button ${activeTab === "cc" ? "active" : ""}`} onClick={() => setActiveTab("cc")}>
                                                <span>CC Invoice Summary</span>
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                                
                                <div className="report-wraper">
                                    <div className="tab-content" id="myTabContent">
                                        {activeTab === "job" && <JobSummary />}
                                        {activeTab === "tc" && <TCInvoiceSummary />}
                                        {activeTab === "cc" && <CCInvoiceSummary />}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default Reports;